
/**
 * @ngdoc module
 * @name mw.components.mediaSourceDocument
 * @description
 *
 */

import { NgModule } from 'ng-metadata/core';
import { MediaSourceDocumentAddressComponent } from './address/address.component';
import { MediaSourceDocumentComponent } from './media-source-document.component';
import { MediaSourceDocumentHeaderComponent } from './header/header.component';
import { MediaSourceDocumentWebComponent } from './web/web.component';
import { MediaSourceDocumentGeofocusComponent } from './geofocus/geofocus.component';
import { MediaSourceDocumentDetailsComponent } from './company-details/company-details.component';
import { MediaSourceDocumentRelevantArticlesComponent } from './relevant-articles/relevant-articles.component';
import { MediaSourceDocumentStaffMembersComponent } from './staff-members/staff-members.component';

@NgModule({
    declarations: [
        MediaSourceDocumentAddressComponent,
        MediaSourceDocumentComponent,
        MediaSourceDocumentDetailsComponent,
        MediaSourceDocumentGeofocusComponent,
        MediaSourceDocumentHeaderComponent,
        MediaSourceDocumentRelevantArticlesComponent,
        MediaSourceDocumentStaffMembersComponent,
        MediaSourceDocumentWebComponent,
    ]
})
export class MediaSourceDocumentModule {}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-source-document/media-source-document.module.ts